import { extractSiteGroupingProps } from '@hotjar/webapp/tracking/utils.ts';

angular.module('hjApp.ui').service('ModalPrompt', [
    '$modal',
    function ($modal) {
        var ModalPromptCtrl = [
            '$scope',
            '$modalInstance',
            'header',
            'text',
            'posButtonText',
            'negButtonText',
            'posCallback',
            'negCallback',
            'posButtonColor',
            'modalTrackingName',
            'Track',
            'UserData',
            function (
                $scope,
                $modalInstance,
                header,
                text,
                posButtonText,
                negButtonText,
                posCallback,
                negCallback,
                posButtonColor,
                modalTrackingName,
                Track,
                UserData
            ) {
                const site = UserData.get('currentSite');
                const siteGroupData = extractSiteGroupingProps(site);

                $scope.header = header;
                $scope.text = text;

                if (modalTrackingName) {
                    Track.loadedModal(modalTrackingName, siteGroupData);
                }

                const posClick = function () {
                    $scope.close();
                    if (_.isFunction(posCallback)) {
                        posCallback();
                    }
                };

                const negClick = function (eventType) {
                    if (modalTrackingName) {
                        const reasons = {
                            x: 'Close X',
                            cancel: 'Cancel Button'
                        };
                        Track.closedModal(modalTrackingName, siteGroupData, {
                            reason: reasons[eventType] ?? 'unknown reason'
                        });
                    }

                    $scope.close();
                    if (_.isFunction(negCallback)) {
                        negCallback();
                    }
                };

                $scope.close = function () {
                    $modalInstance.close();
                };

                $scope.posButton = {
                    onClick: posClick,
                    text: posButtonText,
                    kind: posButtonColor || 'danger'
                };

                $scope.negButton = {
                    onClick: negClick,
                    text: negButtonText
                };
            }
        ];

        this.show = function (
            header,
            text,
            posButtonText,
            negButtonText,
            posCallback,
            negCallback,
            posButtonColor,
            modalTrackingName
        ) {
            return $modal.open({
                templateUrl: 'modal_prompt.html',
                controller: ModalPromptCtrl,
                size: 'sm',
                backdrop: 'static',
                windowClass: 'modal-confirm',
                resolve: {
                    header: function () {
                        return header;
                    },
                    text: function () {
                        return text;
                    },
                    posButtonText: function () {
                        return posButtonText;
                    },
                    negButtonText: function () {
                        return negButtonText;
                    },
                    posCallback: function () {
                        return posCallback;
                    },
                    negCallback: function () {
                        return negCallback;
                    },
                    posButtonColor: function () {
                        return posButtonColor;
                    },
                    modalTrackingName: function () {
                        return modalTrackingName;
                    }
                }
            });
        };
    }
]);
